export const Color = {
  Blue: "#0072e3",
  yellow_3: "#fed600",
  f7f8fa: "#f7f8fa",
  gray_3: "#cccccc",
  "222222": "#222222",
  gray_18: "#e2e2e2",
  gray_6: "#151515",
  White: "#ffffff",
  Black: "#000000",
  Transparent: "transparent",
  red_1: "#ff2f2f",
  Gold: "#ffe4be",
};

export const hexToRgba = (hex: string, alpha?: number): string => {
  if (!hex.startsWith("#")) {
    return hex;
  }
  alpha = alpha === undefined ? 1 : alpha;
  const red = parseInt(
    hex.length == 4 ? hex.slice(1, 2).repeat(2) : hex.slice(1, 3),
    16
  );
  const green = parseInt(
    hex.length == 4 ? hex.slice(2, 3).repeat(2) : hex.slice(3, 5),
    16
  );
  const blue = parseInt(
    hex.length == 4 ? hex.slice(3, 4).repeat(2) : hex.slice(5, 7),
    16
  );
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};
